import { render, staticRenderFns } from "./BulmaTable.vue?vue&type=template&id=3f5e1f6f&scoped=true"
import script from "./BulmaTable.vue?vue&type=script&lang=js"
export * from "./BulmaTable.vue?vue&type=script&lang=js"
import style0 from "./BulmaTable.vue?vue&type=style&index=0&id=3f5e1f6f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e1f6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5e1f6f')) {
      api.createRecord('3f5e1f6f', component.options)
    } else {
      api.reload('3f5e1f6f', component.options)
    }
    module.hot.accept("./BulmaTable.vue?vue&type=template&id=3f5e1f6f&scoped=true", function () {
      api.rerender('3f5e1f6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaTable/BulmaTable.vue"
export default component.exports